import api from './api';

const getMe = () =>
    api.request({
        method: 'GET',
        url: '/user/me'
    });

const lockUser = () =>
    api.request({
        method: 'POST',
        url: '/lock-user'
    });

const isUserLocked = () =>
    api.request({
        method: 'GET',
        url: '/is-user-locked'
    });

export default {
    getMe,
    lockUser,
    isUserLocked
};
